"use strict";

import angular from "angular";

import _ from "lodash";
import { CompanyContact } from "../../../entity/CompanyContact";
import { CompanyContactHttpGateway } from "../../../gateway/CompanyContact/CompanyContactHttpGateway";
import { Events } from "../../../presentation/services/Events/Events";
import { DDI_OPTIONS } from "../../constants/ddi.constants";
import template from "./company-contacts-form.component.html";
import "./company-contacts-form.component.scss";

("use strict");

class CompanyContactsFormComponent {
    messageError = "";
    CompanyContactHttpGateway = new CompanyContactHttpGateway();
    formsContact = [];
    access = [];
    contacts = [];
    contactsRemoved = [];
    accessOpened = [];
    loading = false;
    skeletonInit = true;
    contactsFake = new Array(1);
    accessFake = new Array(4);
    hasChanges = false;
    contactsView = [];
    ddiOptions = DDI_OPTIONS;
    currentDDI = this.ddiOptions[0];
    Events = new Events();
    constructor($scope, LoaderService) {
        this.$scope = $scope;

        this.LoaderService = LoaderService;
    }

    $onInit() {
        this.contactsView = angular.copy(this.contacts);

        const contactModel = {
            name: "",
            email: "",
            whatsapp: "",
            companyId: this.company?._id,
            accountingId: this.accountingData._id,
            type: this.type,
            relations: {
                nps: {
                    status: false
                },

                user: {
                    status: false
                }
            }
        };
        if (this.type === "others") {
            delete contactModel.relations.user;
            delete contactModel.relations.nps;
            contactModel.companyId = this.companyName || "";
        }
        const newContact = CompanyContact.restore(contactModel);

        if (this.action === "edit-add") {
            this.contactsView.push(newContact);
        } else {
            if (!this.contactsView?.length) this.contactsView = [newContact];
        }
        if (["add", "edit-add"].includes(this.action)) {
            this.accessOpened = [this.contactsView.length - 1];
        }
        this.skeletonInit = false;
        if (this.focus >= 0) this.focusContact();
        this.setAccessByType();

        this.$scope.$on("triggerSaveContacts", () => {
            this.onSave();
        });
    }

    isHasNoData() {
        return !this.contactsView?.filter(
            (c) => c.props?.name && c.props?.email
        ).length;
    }

    $onChanges(changes) {
        if (
            (changes.company && !changes.company.isFirstChange()) ||
            (changes.type && !changes.type.isFirstChange()) ||
            (changes.companyName && !changes.companyName.isFirstChange())
        ) {
            this.contactsView = this.contactsView.map((contact) => {
                if (this.type === "others") {
                    contact.props.companyId = this.companyName || "";
                    contact.props.company = this.companyName || "";
                    delete contact.props.relations.nps;
                    delete contact.props.relations.user;
                } else {
                    delete contact.props.company;
                    contact.props.companyId = this.company?._id || "";
                    contact.setRelationStatus("nps.status", false);
                    contact.setRelationStatus("user.status", false);
                }
                contact.props.type = this.type || "";
                return contact;
            });
            this.setAccessByType();
        }
    }

    setAccessByType() {
        if (this.type === "company") {
            this.access = [
                {
                    name: "NPS",
                    path: "nps.status",
                    tooltip: "Pesquisa de satisfação enviada de 3 em 3 meses"
                },

                {
                    name: "Login Nucont",
                    path: "user.status",
                    tooltip:
                        "Acesso para visualizar dashboards, demonstrações e Dash da empresa do contato"
                }
            ];
        } else {
            this.access = [];
        }
    }

    focusContact() {
        try {
            setTimeout(() => {
                const contactElement = document.querySelector(
                    `[data-contact-index="${this.focus}"]`
                );
                if (contactElement) {
                    contactElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                }
                setTimeout(() => {
                    const contactElementInput = document.querySelector(
                        `.contact-input-name-${this.focus} input`
                    );
                    if (contactElementInput) contactElementInput.focus();
                }, 500);
            }, 1000);
        } catch (err) {}
    }

    saveIsDisabled() {
        if (this.type === "others") {
            if (
                this.loading ||
                this.isFormDisabled() ||
                this.isHasNoData() ||
                !this.hasChanges ||
                !this.companyName
            )
                return true;
        } else {
            if (this.action === "edit-add") {
                if (
                    this.loading ||
                    this.isFormDisabled() ||
                    this.isHasNoData() ||
                    !this.company?._id
                )
                    return true;
            } else {
                if (
                    this.loading ||
                    this.isFormDisabled() ||
                    this.isHasNoData() ||
                    !this.hasChanges ||
                    !this.company?._id
                )
                    return true;
            }
        }
    }

    removeIsDisabled(index) {
        return false;
        if (this.loading) return true;
        if (this.action === "add") {
            if (this.contactsView?.length === 1 && index === 0) return true;
        }
        if (
            this.action === "edit" ||
            this.actions === "edit-add" ||
            this.actions === "edit-only"
        )
            return false;
    }

    toggleAccess(index) {
        if (this.accessOpened.includes(index)) {
            this.accessOpened = this.accessOpened.filter(
                (openedIndex) => openedIndex !== index
            );
        } else {
            this.accessOpened.push(index);
        }
    }

    isOpenedAccess(index) {
        return this.accessOpened.includes(index);
    }

    onAddContact() {
        this.hasChanges = true;
        const contactModel = {
            name: "",
            email: "",
            companyId: this.company?._id,
            accountingId: this.accountingData._id,
            type: this.type,
            whatsapp: "",
            relations: {
                nps: {
                    status: false
                },
                user: {
                    status: false
                }
            }
        };
        if (this.type === "others") {
            delete contactModel.relations.user;
            delete contactModel.relations.nps;
            contactModel.companyId = this.companyName || "";
        }
        const contact = CompanyContact.restore(contactModel);
        const length = this.contactsView.push(contact);
        this.accessOpened.push(length - 1);
        this.afterAddContact({ contact });
    }

    async onRemoveContact(contact, index) {
        this.contactsView.splice(index, 1);
        if (contact.props._id) {
            this.contactsRemoved.push(angular.copy(contact));
            this.hasChanges = true;
        }
        this.afterRemoveContact({ contact });
        this.accessOpened = [0];

        if (this.type === "others") {
            this.Events.send("contatos.outros.sidebar.excluir.contato");
        } else {
            this.Events.send("contatos.empresasnucont.sidebar.excluir.contato");
        }

        if (this.action === "edit-add" || this.action === "edit") {
            this.loading = true;

            if (this.contactsRemoved.length) {
                const contactsIds = this.contactsRemoved
                    .filter((c) => c?.props?.name && c?.props?.email)
                    .map((contact) => contact.props._id);
                await this.CompanyContactHttpGateway.removeById({
                    accountingId: this.accountingData._id,
                    type: this.type,
                    _ids: contactsIds
                });

                this.afterSave({ contacts: this.contactsView, notClose: true });
                this.contactsRemoved = [];
                this.loading = false;
                this.$scope.$applyAsync();
            }
        }
    }

    isFormDisabled() {
        return this.formsContact
            .filter((form) => {
                if (!form) return false;
                return Object.keys(form)
                    .filter(
                        (key) =>
                            key[0] !== "$" &&
                            form[key].$modelValue !== undefined
                    )
                    .some((key) => {
                        const val = form[key].$modelValue;
                        return val !== "" && val !== null && val !== undefined;
                    });
            })
            .some((form) => form.$invalid);
    }

    onChangeForm() {
        this.hasChanges = true;
    }

    onCancel() {
        this.hasChanges = false;
        this.afterCancel();
    }

    async onSave() {
        this.messageError = "";
        this.LoaderService.setProgress(true);
        this.hasChanges = false;
        this.loading = true;
        const contacts = angular
            .copy(this.contactsView)
            .filter((c) => c?.props?.name && c?.props?.email);

        const contactsList = contacts.map((contact) => {
            contact.transformRelations();
            contact.setWhatsapp();
            return contact.getProps();
        });

        const response = await this.CompanyContactHttpGateway.saveMany({
            accountingId: this.accountingData._id,
            type: this.type,
            contacts: contactsList
        });

        if (response?.name === "InvalidProps") {
            this.messageError = "Whatsapp parece está invalido.";
            this.LoaderService.setProgress(false);
            this.loading = false;
            this.$scope.$applyAsync();
            return;
        }

        this.messageError = "";
        if (this.contactsRemoved.length) {
            const contactsIds = this.contactsRemoved.map(
                (contact) => contact.props._id
            );
            await this.CompanyContactHttpGateway.removeById({
                accountingId: this.accountingData._id,
                type: this.type,
                _ids: contactsIds
            });
        }
        this.LoaderService.setProgress(false);
        this.loading = false;
        const contatosSalvos = contactsList.filter((c) => !c._id);
        if (this.type === "others") {
            this.Events.setParamns({
                accountingId: this.accountingData._id,
                companyId:
                    this.company?._id || this.company?.name || this.companyName,
                contatosSalvos: contatosSalvos?.length || 0
            });
            this.Events.send("contatos.outros.salvar.manualmente");
        } else {
            this.Events.setParamns({
                accountingId: this.accountingData._id,
                companyId: this.company?._id,
                contatosSalvos: contatosSalvos?.length || 0
            });
            this.Events.send("contatos.empresasnucont.salvar.manualmente");
        }
        this.afterSave({ contacts: this.contactsView });
        this.$scope.$applyAsync();
    }

    onToggleAccess(contact, path) {
        if (this.isAccessDisabled(path)) return false;
        this.onChangeForm();
        contact.toggleRelationStatus(path);
    }

    isCheckedAccess(contact, path) {
        return _.get(contact, `props.relations.${path}`);
    }

    isAccessDisabled(accessPath) {
        if (accessPath === "user.status" && this.company?.status === "INATIVO")
            return true;
        return false;
    }

    getTooltipSwitchAccess(accessPath) {
        if (this.isAccessDisabled(accessPath))
            return `<span class="font-weight-semi-bold">Esta empresa está com licença inativa.</span> Acesse <span class="font-weight-semi-bold">'Minha Assinatura'</span> para solicitar a mudança ou entre em contato com o Administrador.`;
        return ``;
    }
}

export { CompanyContactsFormComponent };

CompanyContactsFormComponent.$inject = ["$scope", "LoaderService"];

const name = "companyContactsFormComponent";
const def = {
    bindings: {
        afterAddContact: "&",
        afterRemoveContact: "&",
        afterCancel: "&",
        afterSave: "&",
        company: "<",
        companyName: "<",
        contacts: "<",
        type: "<",
        action: "<",
        accountingData: "<",
        focus: "=",
        hideButtons: "@"
    },
    controller: CompanyContactsFormComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
